/**
 * Public SongSnap share URLs (web routes on song.appixi.net, not /api).
 */
export const getShareBaseUrl = () => {
  const api = process.env.REACT_APP_API_URL || 'https://song.appixi.net/api';
  const trimmed = api.replace(/\/api\/?$/, '');
  return trimmed || 'https://song.appixi.net';
};

/** Public SongSnap player for a single song (task_id). */
export const getSongShareUrl = (taskId) => {
  if (!taskId) return '';
  return `${getShareBaseUrl()}/songs/share/${encodeURIComponent(taskId)}`;
};

/** All public done songs for a device. */
export const getDeviceShareUrl = (deviceId) => {
  if (!deviceId) return '';
  return `${getShareBaseUrl()}/songs/share/by-device/${encodeURIComponent(deviceId)}`;
};
